// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../../node_modules/postcss-loader/dist/cjs.js!../../style/colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jb3g3KXrCchs7bxYAnfb {
  height: 42px;
  width: 100%;
  border: 1px solid #E2E9FC;
  box-sizing: border-box;
  border-radius: 5px;
  color: #AEADBE;
  padding-left: 8px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: white;
  font-family: 'Roboto', sans-serif;
}

.RlBZV67UQLADsIfyAZ1Z {
  width: 100%;
  border: 1px solid #C4C4C4;
  box-sizing: border-box;
  border-radius: 5px;
  color: #AEADBE;
  padding-left: 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: white;
}

.jb3g3KXrCchs7bxYAnfb .i4nbv2RvThIigphVXcAR {
  display: none;
}

.jb3g3KXrCchs7bxYAnfb input {
  border: none;
  height: 40px;
  width: 98%;
  box-sizing: border-box;
  outline: none;
  background: none;
  color: black;
  font-family: 'Roboto', sans-serif;
}

.RlBZV67UQLADsIfyAZ1Z textarea {
  border: none;
  height: 250px;
  width: 98%;
  margin: auto;
  box-sizing: border-box;
  outline: none;
  background: none;
  color: black;
  resize: none;
}

.jb3g3KXrCchs7bxYAnfb:focus-within, .iN5uEvoNNwaWSWQEOX_u, .jb3g3KXrCchs7bxYAnfb:hover {
  border-color: #526AF2;
  outline: none;
  transition: .3s;
  cursor: pointer;
}

.jb3g3KXrCchs7bxYAnfb:focus-within {
  box-shadow: 0px 0px 6px #b1bdff;
}

.wH9Qy0PhXgNwSw0VwH4c {
  margin-bottom: 4px;
  margin-top: 8px;
  text-align: left;
  font-size: 16px;
}

.nz18ZYZCTZMX8F0vFR7A {
  font-size: 12px;
  margin-top: 4px;
}

.FDF64eFc3Q_HIQz_I8iU {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple"]};
  margin-right: 4px;
}

@media screen and (max-width: 450px) {
  .jb3g3KXrCchs7bxYAnfb {
    height: unset;
    min-height: 42px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/library/Input/shared/Input.module.css"],"names":[],"mappings":"AAGA;EACE,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,UAAU;EACV,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mDAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE;IACE,aAAa;IACb,gBAAgB;EAClB;AACF","sourcesContent":["@value colors: \"../../style/colors.css\";\n@value color-purple from colors;\n\n.input {\n  height: 42px;\n  width: 100%;\n  border: 1px solid #E2E9FC;\n  box-sizing: border-box;\n  border-radius: 5px;\n  color: #AEADBE;\n  padding-left: 8px;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  background-color: white;\n  font-family: 'Roboto', sans-serif;\n}\n\n.textarea {\n  width: 100%;\n  border: 1px solid #C4C4C4;\n  box-sizing: border-box;\n  border-radius: 5px;\n  color: #AEADBE;\n  padding-left: 0;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  background-color: white;\n}\n\n.input .ant-tooltip {\n  display: none;\n}\n\n.input input {\n  border: none;\n  height: 40px;\n  width: 98%;\n  box-sizing: border-box;\n  outline: none;\n  background: none;\n  color: black;\n  font-family: 'Roboto', sans-serif;\n}\n\n.textarea textarea {\n  border: none;\n  height: 250px;\n  width: 98%;\n  margin: auto;\n  box-sizing: border-box;\n  outline: none;\n  background: none;\n  color: black;\n  resize: none;\n}\n\n.input:focus-within, .inputActive, .input:hover {\n  border-color: #526AF2;\n  outline: none;\n  transition: .3s;\n  cursor: pointer;\n}\n\n.input:focus-within {\n  box-shadow: 0px 0px 6px #b1bdff;\n}\n\n.label {\n  margin-bottom: 4px;\n  margin-top: 8px;\n  text-align: left;\n  font-size: 16px;\n}\n\n.hint {\n  font-size: 12px;\n  margin-top: 4px;\n}\n\n.required {\n  color: color-purple;\n  margin-right: 4px;\n}\n\n@media screen and (max-width: 450px) {\n  .input {\n    height: unset;\n    min-height: 42px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colors": `"../../style/colors.css"`,
	"color-purple": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple"]}`,
	"input": `jb3g3KXrCchs7bxYAnfb`,
	"textarea": `RlBZV67UQLADsIfyAZ1Z`,
	"ant-tooltip": `i4nbv2RvThIigphVXcAR`,
	"inputActive": `iN5uEvoNNwaWSWQEOX_u`,
	"label": `wH9Qy0PhXgNwSw0VwH4c`,
	"hint": `nz18ZYZCTZMX8F0vFR7A`,
	"required": `FDF64eFc3Q_HIQz_I8iU`
};
export default ___CSS_LOADER_EXPORT___;
